const x = (m, h) => {
  let k = h ? (h == null ? void 0 : h.length) > 0 : !1, p = !1;
  return h == null || h.forEach((v) => {
    const g = !!m(v);
    k && (k = g), p || (p = g);
  }), { every: k, some: p };
};
export {
  x as checkRefundStatusCollection
};
